import { isError, isString } from 'lodash-es';

import { isObject } from './object';

export const UNKNOWN_ERROR_MESSAGE = 'An unknown error occurred.';

/** Check if the given value is an "error-like" object. */
export function isErrorLike(
  value: unknown
): value is { message: string; [key: string]: unknown } {
  if (isError(value)) return true;
  return isObject(value) && isString(value['message']);
}

/**
 * Parses an "error-like" value, returning a default message if the value is not
 * a string or an `Error` instance.
 */
export function parseError(
  value: unknown,
  fallbackMessage = UNKNOWN_ERROR_MESSAGE
): string {
  if (isErrorLike(value)) return value.message;
  if (isString(value)) return value;

  return fallbackMessage;
}

/** Ensure an unknown value has `Error` interface. */
export function ensureError(error: unknown): Error {
  if (isError(error)) return error;

  if (isString(error)) {
    return new Error(error || UNKNOWN_ERROR_MESSAGE);
  }

  if (isErrorLike(error)) {
    const err = new Error(error.message);

    if (isString(error['stack'])) {
      err.stack = error['stack'];
    }

    if (isString(error['name'])) {
      err.name = error['name'];
    }

    return err;
  }

  try {
    return new Error(`Error: ${JSON.stringify(error)}`);
  } catch {
    return new Error(`Error: ${String(error)}`);
  }
}
